import { render, staticRenderFns } from "./accounting-historical-invoices.vue?vue&type=template&id=093f8604&"
import script from "./accounting-historical-invoices.vue?vue&type=script&lang=js&"
export * from "./accounting-historical-invoices.vue?vue&type=script&lang=js&"
import style0 from "./accounting-historical-invoices.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports